(function scrollIntoView() {
    var scrollLinks = document.querySelectorAll('.js-scroll');
    scrollLinks.forEach(function (link) {
        // addEventListener is just the same as jQuery’s .on()
        // we can listen for events on elements and then run a function
        link.addEventListener('click', function (event) {
            // using the event keyword we get access to a snapshot of what
            // happened when we clicked on our link
            // this is equivalent to return false in jQuery
            // it will block the default browser behaviour of the link jumping to
            // the href attribute
            event.preventDefault();
            // here we grab the href attribute from our link
            var href = link.getAttribute('href');
            console.log(href);
            // here we use the new  scrollIntoView feature to scroll to
            // our desired element in a smooth fashion
            document.querySelector(href).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });
})();
